import { visionURL } from "../config/environment";
import JsonApiService from "../services/jsonapiService";
import visionCallService from "../services/visionCallService";

const deepLinkService = async () =>
  new JsonApiService("customer_deep_links", {
    baseUrl: `${visionURL}/deep_linking`,
    credentials: "include"
  });

export const useDeepLinks = () => {
  const createDeepLink = async (customerId, trainingObjectId) => {
    const service = await deepLinkService();
    const response = await service
      .customParams({
        customer_id: customerId,
        training_object_id: trainingObjectId
      })
      .create(
        visionCallService.serializeRequestBody(
          { customerId, trainingObjectId },
          "customerDeepLink"
        )
      )
      .then(response => response.json());
    return response;
  };

  return { createDeepLink };
};
